import React from "react";
import { Button, useNotify } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import dataProvider from "server/dataProvider";
import { scholarshipRequests } from "api/scholarshipApi";

const UpdateStatusDialog = ({ campaignId, excludedIds, allSeenIds, fetchApprovedApplications, resetSelection }) => {
  const notify = useNotify();

  const handleSubmit = async () => {
    // всички видени id-та минус дечекнатите
    const approvedApplicationIds = allSeenIds.filter(id => !excludedIds.includes(id));
    //    дечекнатите id-та от потребителя
    const excludedApplicationIds = excludedIds;

    await dataProvider.customRequest(
      scholarshipRequests.updateApprovedScholarshipStatus(),
      {
        campaignId,
        approvedApplicationIds,
        excludedApplicationIds,
      },
      "PUT",
    );
    notify("Успешно променихте статусите на кандидатурите", { type: "success" });
    // Clear the accumulated selection so the reload re-seeds from the updated server statuses.
    resetSelection?.();
    fetchApprovedApplications();
  };

  return (
    <ConfirmModal
      onConfirm={handleSubmit}
      titleContent={"Промени статус на кандидатури"}
      message={
        'Маркираните кандидатури, ще бъдат "Одобрени", а немаркираните "Некласирани". Сигурни ли сте, че искате да промените статусите на избраните кандидатури?'
      }
      triggerButton={
        <Button
          label="Запази"
          variant="contained"
          color="success"
          size="medium"
          startIcon={<SaveAsIcon />}
          mt={2}
        />
      }
    />
  );
};

export default UpdateStatusDialog;
